import React, { Dispatch, SetStateAction, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { IFavoritesFilter } from '../dto/IDiscoveryFilter';
import { Col } from 'react-bootstrap';
import { ICollaboration } from '../../../../../model/shared/ICollaboration';
import { CustomAutocomplete } from '../../../../../shared/components/Autocomplete';
import { SearchInput } from '../../../../../shared/components/SearchInput';

interface FavoriteUserListHeaderSearchProps {
    setFilterParams: Dispatch<SetStateAction<IFavoritesFilter>>;
    collaborations?: ICollaboration[];
    setFilterCollaborations?: Dispatch<SetStateAction<{ username: string }>>;
    isFilterLoading?: boolean;
}

const FavoriteUserListHeaderSearch = ({
    setFilterParams,
    collaborations,
    setFilterCollaborations,
    isFilterLoading = false,
}: FavoriteUserListHeaderSearchProps) => {
    const { t } = useTranslation();

    const handleSearch = (value: string, name: string) => {
        setFilterParams(prev => ({
            ...prev,
            [name]: value,
            page: 1,
        }));
    };

    const multipleSelectHandler = useCallback(
        (paramKey: string, paramValue: any) => {
            setFilterParams(prev => ({
                ...prev,
                [paramKey]: !!paramValue?.username?.length ? paramValue.username : null,
                page: 1,
            }));
        },
        [setFilterParams]
    );

    return (
        <>
            <Col lg={4} md={6}>
                <SearchInput
                    name="search"
                    onSearch={handleSearch}
                    isLoading={isFilterLoading}
                    debounceMs={500}
                    label={t('general.button.search')}
                />
            </Col>
            <Col xl={3} lg={4} md={6}>
                <CustomAutocomplete
                    dataArray={collaborations ?? []}
                    isWithImage={true}
                    inputLabel="collaboration_name"
                    photoLabel="collaboration_logo"
                    disableClearable={false}
                    queryFilterKey="brandUsername"
                    changeEventKey="username"
                    inputLabelTranslation={t('brand.campaign.discovery.collabs')}
                    handleChangeParams={multipleSelectHandler}
                    classes="my-3 mb-my-0"
                    setFilterState={setFilterCollaborations}
                    isDisabled={isFilterLoading}
                />
            </Col>
        </>
    );
};

export default FavoriteUserListHeaderSearch;
